import React, {useContext, useEffect, useState} from 'react';
import CouponBanner from "../../components/CouponBanner";
import {Redirect, useHistory} from "react-router-dom";
import {ApiServicev2, CouponServicev2, SwapService} from "../../api/Apiv2";
import withReactContent from "sweetalert2-react-content";
import Swal from 'sweetalert2'
import {InfoContext} from "../../config/InfoContext";
import styled from "styled-components"
import Confetti from 'react-confetti'
import NumberPadPrinter from "../../components/NumberPadPrinter";
import Button from "../../components/Button";
import Modal from "../../components/Modal";
import {getDocumentType} from '../../components/services';

export const PointsContainer = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 4px;
`

const CouponContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: start;
    padding-bottom: 1rem;
    overflow-y: auto;
`

const StyledInput = styled.input`
  width: 300px;
  padding: 10px;
  font-size: 2rem;
  font-weight: bold;
  text-align: center;
  margin-bottom: 16px;
  border: 1px solid rgb(204, 204, 204);
  border-radius: 6px;
  ::placeholder {
    color: #d3d3d3;
    font-weight: normal;
    opacity: 1;
  }
`;

const MySwal = withReactContent(Swal);

export const showAlert = (message) => {
  return MySwal.fire({
    title: message,
    icon: 'error',
  })
};

const CouponList = () => {

  const [loading, setLoading] = useState(false);
  const [showConfetti, setShowConfetti] = useState(true)
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedCoupon, setSelectedCoupon] = useState(null);
  const [quantity, setQuantity] = useState("");
  const globalConfig = getDocumentType()

  const numpad = globalConfig.numpad || false

  const startLoading = () => setLoading(true);
  const stopLoading = () => setLoading(false);

  const history = useHistory();

  const {sala, printer, document, card} = useContext(InfoContext);
  const [data, setData] = useState(null)

  useEffect(() => {
    getCouponData(); // Obtener los datos iniciales
  }, []);

  useEffect(() => {
    if (data) { // Ejecutar `verifyRedeemStatus` solo cuando `data` tenga un valor
      if (sala !== null && (sala.id === 999 || sala.id === 127)) {
        verifyRedeemStatus();
      }
    }
  }, [data]);

  const verifyRedeemStatus = async () => {
    const params = {
      customerId: data?.person?.id,
      productId: 772, // Producto específico para el panetón
    };

    try {
      const response = await SwapService.checkQuantityRedeems({params});
      const {quantity, stock} = response;

      if (quantity > 0 || stock <= 0) {
        setShowConfetti(false);
      } else if (sala.id === 999 || sala.id === 127) {
        const showWelcomeAlert = async () => {
          const {isConfirmed, isDismissed} = await MySwal.fire({
            title: '¡Felicidades!',
            text: 'Ganaste un panetón Gratis!',
            icon: 'success',
            showCancelButton: true,
            confirmButtonText: 'Canjear premio',
            cancelButtonText: 'Cancelar canje',
          });

          if (isConfirmed) {
            saveSwap();
          } else if (isDismissed) {
            cancelSwap();
          }
        };
        showWelcomeAlert();
        setShowConfetti(true);
      }
    } catch (error) {
      setShowConfetti(false);
      console.error(error);
    }
  };

  const cancelSwap = () => {
    MySwal.fire({
      title: 'Canje cancelado',
      text: 'Has cancelado el canje del premio.',
      icon: 'info',
    });
  };

  const saveSwap = () => {
    history.push({
      pathname: "/redeem",
      search: `?customerId=${data.person.id}&productId=772&salaId=${sala.id}`,
    });
  };

  const getCouponData = () => {
    const params = {document: document, card: card};

    ApiServicev2.couponSummary(params).then(res => {
      setData(res.data);
    }).catch(error => {
      setData(null);
      showAlert(error.message || 'Error al obtener datos del cupón');
    });
  };

  if (sala === null) {
    return <Redirect to={'/configuration'}/>
  }

  const handlePartialPrint = (coupon) => {
    setSelectedCoupon(coupon);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedCoupon(null);
    setQuantity("");
  };

  const confirmPrint = () => {
    if (quantity && parseInt(quantity, 10) > 0) {
      printEvent(selectedCoupon, quantity);
      closeModal();
    } else {
      showAlert("Por favor ingrese una cantidad válida");
    }
  };


  const totalPrint = async (coupon) => {
    const {value: confirm} = await Swal.fire({
      title: 'Deseas imprimir todos tus cupones ?',
      showConfirmButton: true,
      showCancelButton: true,
      cancelButtonText: 'Cancelar',
    });

    if (confirm) {
      const totalCupones = coupon.disponibles;
      printEvent(coupon, totalCupones);
    }
  };

  const printEvent = (coupon, quantity) => {
    startLoading();

    const params = {
      customerId: data.person.id,
      couponTypeId: coupon.couponId,
      quantity: quantity,
      salaId: sala.id,
      printerId: printer.printerId,
      computerId: printer.computerId
    };

    CouponServicev2.buildAndPrint(params).then(data => {
      history.push({
        pathname: '/printing',
        search: `?quantity=${data.quantity}&couponPrintJobId=${data.id}`
      });
    }).catch(error => {
      stopLoading();
      let errorMessage = 'Se produjo un error al procesar la solicitud';
      const statusCode = error.response && error.response.status;

      if (statusCode === 403) {
        errorMessage = 'No tienes permisos para realizar esta acción';
      } else if (statusCode === 500) {
        errorMessage = 'Se produjo un error en el servidor. Inténtalo nuevamente más tarde';
      } else if (error.response && error.response.data && error.response.data.message) {
        errorMessage = error.response.data.message;
      }

      MySwal.fire({
        title: errorMessage,
        icon: 'error',
      });
    });
  };

  const partialDeposit = async (coupon) => {
    //TODO
  }

  const totalDeposit = () => {
    //TODO
  }


  return (
    data && (
      <>
        {showConfetti && sala && (sala.id === 999 || sala.id === 127) && (
          <>
            <Confetti
              tweenDuration={20000}
              initialVelocityY={40}
              initialVelocityX={2.5}
              style={{zIndex: '1061'}}
              numberOfPieces={300}
              recycle={false}
              confettiSource={{x: window.innerWidth * .25, y: window.innerHeight, w: 0, h: 0}}
              onConfettiComplete={() => setShowConfetti(false)}
            />
            <Confetti
              tweenDuration={20000}
              initialVelocityY={40}
              initialVelocityX={2.5}
              style={{zIndex: '1061'}}
              numberOfPieces={300}
              recycle={false}
              confettiSource={{x: window.innerWidth * .75, y: window.innerHeight, w: 0, h: 0}}
              onConfettiComplete={() => setShowConfetti(false)}
            />
          </>
        )}
        <CouponContainer className="scrollbar">
          {data.couponList
            .filter(coupon => coupon.moduleShow)
            .map((coupon) =>
              <div key={coupon.couponId} style={{display: "flex", padding: "0 0.5rem"}}>
                <CouponBanner
                  coupon={coupon}
                  totalPrint={() => totalPrint(coupon)}
                  partialPrint={() => handlePartialPrint(coupon)}
                  totalDeposit={() => totalDeposit(coupon)}
                  partialDeposit={() => partialDeposit(coupon)}
                  loading={loading}
                />
              </div>
            )}
        </CouponContainer>
         <Modal isOpen={isModalOpen} onClose={closeModal}>
          <div style={{color:'black', padding:16, display:"flex", flexDirection:"column",alignItems:"center"}}>
            {numpad ?
              <div style={{display:"flex", flexDirection:"column", width:"100%"}}>
                <span style={{fontWeight: 'bold',fontSize:32}}>Seleccionar Cantidad</span>
                <span style={{fontWeight: 'semibold',fontSize:20}}>Cupón: {selectedCoupon?.couponName}</span>
                <span style={{fontWeight: 'semibold',fontSize:20, marginBottom:'16px'}}>Disponibles: {selectedCoupon?.disponibles}</span>
              </div>
              :
              <span style={{fontWeight: 'bold',fontSize:32, marginBottom:'16px'}}>Ingrese la cantidad de cupones</span>
            }
            <StyledInput
              type="number"
              name='quantity'
              value={quantity}
              placeholder="0"
              onChange={e => {
                const val = e.target.value.replace(/\D/g, "");
                setQuantity(val);
              }}
            />
            {numpad && <NumberPadPrinter value={quantity} onChange={setQuantity}/>}
            <div style={{marginTop: '1rem', display: 'flex', gap:'32px'}}>
              <Button title="Imprimir" onClick={confirmPrint}/>
              <Button title="Cancelar" onClick={closeModal} variant="light"/>
            </div>
          </div>
        </Modal>
      </>
    )
  );

};

export default CouponList;
